export const standardFileList = `/api/unoauth/standard/getStandardFileListPage`; //查询标准文件列表
export const standardFileDetail = `/api/unoauth/standard/getStandardFileDetail`; //查询标准文件详情

export const standardBatchSearchTemplate = `/api/unoauth/standard/exportTemplate`; // 标准批量查新模板
